import './index.css'

import * as Sentry from '@sentry/react'
import React from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'

// Enable sentry in production
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://68b912208e32fc7eb367db2890009218@o164846.ingest.sentry.io/4505751861395456',
    integrations: [
      Sentry.browserTracingIntegration({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', /^https:\/\/flowapp\.bonobolabs\.com\//]
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}

const prod = process.env.NODE_ENV === 'production'
const hostname = window.location.hostname

const allowlist = ['flowapp.bonobolabs.com', 'flowapp-staging.bonobolabs.com']

const needsRedirect = prod && !allowlist.includes(hostname)

if (needsRedirect) {
  const staging = hostname.includes('staging')
  const redirectUrl = staging
    ? 'https://flowapp-staging.bonobolabs.com'
    : 'https://flowapp.bonobolabs.com'

  window.location.replace(redirectUrl)
}

const root = createRoot(document.getElementById('root'))
root.render(<App />)
